<div class="controls" style="margin-bottom: 12px;">
  <label>
    <nz-switch [disabled]="isLoading" [nzUnCheckedChildren]="'Minimized Map' | locale"
      [nzCheckedChildren]="'Full Map' | locale" [(ngModel)]="displayFullMap"
      (ngModelChange)="onDisplayFullMapChange($event)"></nz-switch>
  </label>
</div>
<nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
<nz-graph *ngIf="!isLoading" nz-graph-zoom draggable="true" [nzGraphData]="graphData" [nzAutoSize]="true"
  [nzRankDirection]="rankDirection" (nzGraphInitialized)="graphInitialized($event)">
  <ng-container *nzGraphNode="let node">
    <foreignObject x="0" y="0" class="boxContainer" [ngClass]="{ mainDoc: node.IsMain === true }">
      <xhtml:div class="graph-node leaf-node" (click)="focusNode(node)">
        <div class="title" [ngClass]="{ mainText: node.IsMain === true }">
          {{ node.DocName }}
        </div>
        <div class="content">
          <span class="nodeTotal" *ngIf="node.ObjectType !== 202 && node.DocTotal !== ''">
            {{'Total:' | locale}} <span>{{ node.DocTotal }}</span>
          </span>
          <span class="nodeTotal" *ngIf="node.ObjectType === 202">
            <span>{{ node.DocCurrency }}</span>
          </span>
          <span class="nodeDate">
            {{'Date:' | locale}} <span>{{ node.DocDate }}</span>
          </span>
          <span class="nodeEntry">
            {{'No.' | locale}} <span>{{ node.DocNum }}</span>
          </span>
          <span class="nodeStatus">
            <span *ngIf="node.DocStatus === 'P'">Planned</span>
            <span *ngIf="node.DocStatus === 'R'">Released</span>
            <i *ngIf="node.DocStatus === 'O'" class="fas fa-lock-open-alt" style="color: gold"></i>
            <i *ngIf="node.DocStatus === 'C' && node.CANCELED === 'N'" class="fas fa-lock" style="color: gold"></i>
            <ng-container *ngIf="node.DocStatus === 'C' && node.CANCELED === 'Y'">
              <i class="fas fa-ban" style="color: red"></i> {{ 'Canceled' | locale }}
            </ng-container>
            <ng-container *ngIf="node.DocStatus === 'C' && node.CANCELED === 'C'">
              <i class="fas fa-ban" style="color: red"></i> {{ 'Cancellation Document' | locale }}
            </ng-container>
          </span>
        </div>
      </xhtml:div>
    </foreignObject>
  </ng-container>
</nz-graph>
